export const websocketModels = (props) =>{
    return {
        "clientid":"",
        "subscriptions":{},
        "messages":{},
        "contacts":{}
    };
};
